import { EIIState } from 'app/shared/enums/international-invoice.enums';

export const ZEBRA_ALLOWED_PRINT_STATES: EIIState[] = [
  EIIState.VERIFIED,
];
